const midnight = new Date();
midnight.setHours(0, 0, 0, 0);

export const filterOptions = [
  {
    key: "همه",
    value: {
      start: new Date(
        new Date().setDate(new Date().getDate() - 365)
      ).toISOString(),
      end: new Date().toISOString(),
    },
  },
  {
    key: "امروز",
    value: {
      start: midnight.toISOString(),
      end: new Date().toISOString(),
    },
  },
  {
    key: "دیروز",
    value: {
      start: new Date(midnight.getTime() - 24 * 60 * 60 * 1000).toISOString(),
      end: midnight.toISOString(),
    },
  },
  {
    key: "یک هفته گذشته",
    value: (() => {
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = یکشنبه، 6 = شنبه
      const thisSaturday = new Date(midnight);
      console.log(dayOfWeek);
      if (dayOfWeek != 6) {
        thisSaturday.setDate(midnight.getDate() - dayOfWeek); // شنبه این هفتهo
      }
      const lastSaturday = new Date(thisSaturday);
      lastSaturday.setDate(thisSaturday.getDate() - 7); // شنبه هفته قبل

      const lastFriday = new Date(lastSaturday);
      lastFriday.setDate(lastSaturday.getDate() + 6);

      return {
        start: lastSaturday.toISOString(),
        end: thisSaturday.toISOString(),
      };
    })(),
  },
  {
    key: "یک ماه گذشته",
    value: (() => {
      const firstOfThisMonth = new Date(midnight);
      firstOfThisMonth.setDate(1); // ۱ این ماه
      const firstOfLastMonth = new Date(firstOfThisMonth);
      firstOfLastMonth.setMonth(firstOfLastMonth.getMonth() - 1); // ۱ ماه قبل

      return {
        start: firstOfLastMonth.toISOString(),
        end: firstOfThisMonth.toISOString(),
      };
    })(),
  },
];
